module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/057-burundi-8a888f7cf8944a14e529f4aa40446553.svg";